import NavBarHome from "../components/NavBarHome";
import Services_Frame from "../components/Services_Frame";
import Why_Choose_Us_Frame from "../components/Why_Choose_Us_Frame";
import Address_Frame from "../components/Address_Frame";
import WHYCHOOSEUSLEARNMOREPAGE from "./WHYCHOOSEUSLEARNMOREPAGE";
const Services = () => {
  return (
    <div className="w-full relative bg-white min-h-screen text-left text-[44px] text-gray-300 font-istok-web">
      <NavBarHome
        navBarHomeWidth="1690px"
        navBarHomePosition="absolute"
        navBarHomeTop="50px"
        navBarHomeLeft="113px"
        navBarHomeAlignSelf="unset"
      />

      <div className="space-y-10 py-8">
        <Services_Frame />

        <Why_Choose_Us_Frame />
        <WHYCHOOSEUSLEARNMOREPAGE />

        <Address_Frame />
      </div>
     </div> 
  );
};

export default Services;
